module.exports = __webpack_public_path__ + "img/ks_yufu.b28200d6.png";